import { useState, useEffect } from 'react';
import { Modal, Button, Spin, Tag, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const TreatmentReportPreviewModal = ({ open, onClose, record }) => {
  const [status, setStatus] = useState('checking'); // checking | ready | missing
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const reportUrl = record?.reportUrl ?? null;

  useEffect(() => {
    if (!open) {
      setIframeLoaded(false);
      return;
    }
    if (!reportUrl) { setStatus('missing'); return; }
    setStatus('checking');
    setIframeLoaded(false);
    fetch(reportUrl, { method: 'HEAD' })
      .then((res) => setStatus(res.ok ? 'ready' : 'missing'))
      .catch(() => setStatus('missing'));
  }, [open, reportUrl]);

  const handleDownload = async () => {
    if (!reportUrl || status !== 'ready') return;
    const fileName = `treatment-report-${record?.treatmentId || record?.reportId || 'report'}.pdf`;
    try {
      const res = await fetch(reportUrl);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.setAttribute('download', fileName);
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(blobUrl);
    } catch {
      window.open(reportUrl, '_blank');
    }
  };

  return (
    <Modal
      title={
        <span>
          Treatment Report Preview
          {record?.reportId && <Tag color="blue" style={{ marginLeft: 10, borderRadius: 9999 }}>{record.reportId}</Tag>}
        </span>
      }
      open={open}
      onCancel={onClose}
      width={680}
      styles={{ body: { padding: 0 } }}
      footer={
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {status === 'ready' && (
            <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
              Download PDF
            </Button>
          )}
          <Button onClick={onClose}>Close</Button>
        </div>
      }
      destroyOnClose
    >
      {status === 'ready' ? (
        <div style={{ position: 'relative', height: '80vh' }}>
          {!iframeLoaded && (
            <div style={{
              position: 'absolute', inset: 0, display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              background: '#fff', zIndex: 1,
            }}>
              <Spin size="large" tip="Loading PDF..." />
            </div>
          )}
          <iframe
            src={`${reportUrl}#toolbar=0&navpanes=0&scrollbar=0`}
            title="Treatment Report PDF"
            onLoad={() => setIframeLoaded(true)}
            style={{ border: 'none', display: 'block', height: '100%', width: '100%' }}
          />
        </div>
      ) : status === 'checking' ? (
        <div style={{ alignItems: 'center', color: '#888', display: 'flex', flexDirection: 'column', gap: 12, justifyContent: 'center', minHeight: 300 }}>
          <Spin size="large" tip="Loading PDF..." />
        </div>
      ) : (
        <div style={{ minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="No report file available" />
        </div>
      )}
    </Modal>
  );
};

export default TreatmentReportPreviewModal;
